import ApiService from "../service/ApiService";

let moduleApi = {};
let moduleName = "command_queue";

moduleApi.create = async (dataForm, loading) => {
  if (dataForm && !dataForm.agent_id) {
    const urlStr = window.location.hash || window.location.pathname;
    const parts = urlStr.split(/[\/?#]/).filter(Boolean);
    const agentIdFromUrl = parts.find(p => p && p.length === 24);
    if (agentIdFromUrl) {
      dataForm.agent_id = agentIdFromUrl;
    }
  }
  let api = {
    module: moduleName,
    type: "create",
    value: dataForm,
    dontLoading: (loading == undefined ? false : loading ),
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.update = async (dataForm) => {
  let api = {
    module: moduleName,
    type: "partialUpdate",
    value: dataForm
  };
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.list = async (dataFilter) => {
  let api = {
    module: moduleName,
    type: "list",
    value: dataFilter
  };
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.delete = async (id) => {
  let api = {
    module: moduleName,
    type: "delete",
    value: { id: id }
  };
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.findById = async (config, loading) => {
  const value = typeof config === "string" ? { id: config } : config;
  let api = {
    module: moduleName,
    type: "findById",
    value: value,
    dontLoading: (loading == undefined ? false : loading )
  };
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.clearCache = () => {
  ApiService.clearCache(new RegExp("/" + moduleName + "s([/?#].*)?$"));
};
export default moduleApi;
